import React from "react";

import { useTranslation } from "utils";

import { MainPage } from "components";

export const TranslationBranching = () => {
  const { t } = useTranslation("global");

  return (
    <MainPage loading={false} pageName={"admin"}>
      <p>{t("experiments.testString1")}</p>
    </MainPage>
  );
};
